"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Tournament() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const stats = [{
    label: "RARE",
    value: "15%"
  }, {
    label: "FAST",
    value: "SHIPPING"
  }, {
    label: "SECURE",
    value: "VAULT"
  }, {
    label: "NEXT EVENT",
    value: "Jan 15"
  }, {
    label: "LOCATION",
    value: "FLORIDA"
  }];
  return <section data-section-id="22" id="tournament" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden relative dark">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]" style={{
      backgroundImage: "radial-gradient(circle at 1px 1px, hsl(240 5% 85%) 1px, transparent 0)",
      backgroundSize: "32px 32px"
    }} aria-hidden="true" />

      <div className="max-w-7xl mx-auto relative">
        <div className="grid grid-cols-1 lg:grid-cols-[55%_45%] gap-16 lg:gap-12 items-center">
          {}
          <div ref={leftRef} className={`transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-primary" aria-hidden="true" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-primary">sURGEGAMING Competitive Series</span>
            </div>

            {}
            <h2 className="font-default font-semibold leading-[0.95] tracking-tight mb-8 text-foreground" style={{
            fontSize: "clamp(3rem, 6vw, 6rem)"
          }}>
              Tournament
              <br />
              Ready
              <span className="text-primary">.</span>
            </h2>

            {}
            <p className="font-default text-base md:text-lg leading-relaxed max-w-xl mb-10 text-muted-foreground">Join the elite circuit. From local qualifiers to regional championships. Expert deck building, verified card pools, and high-stakes competition await.</p>

            {}
            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-12">
              {stats.map((stat, i) => <div data-index={i} key={stat.label} className="flex items-center gap-4 md:gap-6">
                  <div className="flex flex-col">
                    <span className="font-mono text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">
                      {stat.label}
                    </span>
                    <span className="font-default text-xl md:text-2xl mt-1 text-primary">
                      {stat.value}
                    </span>
                  </div>
                  {i < stats.length - 1 && <Separator orientation="vertical" className="h-10 bg-border" />}
                </div>)}
            </div>

            {}
            <div className="flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="rounded-lg px-7 h-12 font-default text-sm tracking-wide group bg-primary text-primary-foreground hover:opacity-90">
                <Link to="#">
                  Register Now
                  <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="rounded-lg px-7 h-12 font-default text-sm tracking-wide bg-transparent border-foreground text-foreground">
                <Link to="/ShopPage">
                  Tournaments
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-700 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto">
              {}
              <div className="relative h-full w-full rounded-lg overflow-hidden shadow-lg border border-border">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699827/img/deckx_tournament_card.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699827/img/deckx_tournament_card.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699827/img/deckx_tournament_card.png-wvc-sizes" alt="DECKX competitive trading card in protective slab" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </div>

              {}
              <div className="absolute -left-6 md:-left-12 top-8 md:top-12 rotate-[-6deg] shadow-md bg-card border border-border" style={{
              padding: "1rem 1.5rem",
              clipPath: "polygon(2% 8%, 12% 2%, 28% 6%, 45% 1%, 62% 5%, 78% 2%, 95% 7%, 98% 22%, 96% 40%, 99% 58%, 95% 75%, 98% 92%, 82% 96%, 65% 99%, 48% 95%, 30% 98%, 14% 94%, 4% 96%, 1% 78%, 5% 60%, 2% 42%, 6% 24%)"
            }}>
                <div className="flex flex-col items-center">
                  <span className="font-mono text-[0.6rem] tracking-[0.2em] uppercase text-muted-foreground">
                    Series
                  </span>
                  <span className="font-default text-4xl md:text-5xl leading-none mt-1 text-foreground">2026</span>
                </div>
              </div>

              {}
              <div className="absolute -right-4 md:-right-8 -bottom-4 md:-bottom-8 size-28 md:size-36" style={{
              animation: "roastco-stamp-spin 60s linear infinite"
            }}>
                <svg viewBox="0 0 200 200" className="w-full h-full text-primary">
                  <defs>
                    <path id="stamp-circle" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0" />
                  </defs>
                  <circle cx="100" cy="100" r="88" fill="none" stroke="currentColor" strokeWidth="1" />
                  <circle cx="100" cy="100" r="62" fill="none" stroke="currentColor" strokeWidth="1" />
                  <text fill="currentColor" className="font-mono" style={{
                  fontSize: "11px",
                  letterSpacing: "0.18em"
                }}>
                    <textPath href="#stamp-circle" startOffset="0">
                      COMPETITIVE · AUTHENTIC · DECKX · VAULT · 
                    </textPath>
                  </text>
                  <text x="100" y="106" textAnchor="middle" fill="currentColor" className="font-default" style={{
                  fontSize: "14px",
                  letterSpacing: "0.15em"
                }}>
                    DECKX
                  </text>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes roastco-stamp-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </section>;
}